(function() {
  function setupAccordion() {
    var items = document.querySelectorAll('.custom-services-block-item');
    var headers = document.querySelectorAll('.custom-services-block-header');
    if (!items.length || !headers.length) return;
    items.forEach(function(item) {
      item.classList.remove('active');
    });
    headers.forEach(function(header) {
      header.addEventListener('click', function() {
        var item = header.closest('.custom-services-block-item');
        if (!item) return;
        var isActive = item.classList.contains('active');
        items.forEach(function(otherItem) {
          if (otherItem !== item) otherItem.classList.remove('active');
        });
        if (isActive) {
          item.classList.remove('active');
        } else {
          item.classList.add('active');
        }
      });
    });
  }
 
  document.addEventListener('DOMContentLoaded', setupAccordion);
  document.addEventListener('shopify:section:load', setupAccordion);
})();
